'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPublished = undefined;

var _isStatus = require('./isStatus');

var _messageStatusTypes = require('../constants/messageStatusTypes');

var _statusTypes = require('../../common-message-format/constants/statusTypes');

var isPublished = exports.isPublished = function isPublished(message) {
  return (0, _isStatus.isStatus)(_messageStatusTypes.PUBLISHED, message) || (0, _isStatus.isStatus)(_statusTypes.SENT, message);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isPublished.js
// module id = 278
// module chunks = 2 3